import type { Background } from '@/api/types/background'

/**
 * Merging multiple doublePage/fourColor request combos (see `resolveBackgroundsRequestCombos`)
 * should already yield disjoint sets — each background has one fixed doublePageFlag/fourColorFlag
 * — but de-duping by id is cheap insurance against an inconsistent backend.
 */
export function dedupeBackgroundsById(backgrounds: Background[]): Background[] {
  const seen = new Set<string>()
  const result: Background[] = []

  for (const background of backgrounds) {
    if (seen.has(background.backgroundId)) continue

    seen.add(background.backgroundId)
    result.push(background)
  }

  return result
}
